export const ACCOUNT_MENU_WIDTH = 290;